import React, { memo } from "react";
import { Card, CardFooter, CardHeader, ListGroup, ListGroupItem } from "reactstrap";

const translator = require("../../../utils/translator/translator");

const SnoozedListItem = ({ caption = "", snoozePayload, rowData = [{ label: "", value: "" }], Footer = <></>, style = {} }) => {
     return (
          <Card className="w-100" style={{ border: "1px solid rgba(0, 0, 0, 0.376)", ...style }}>
               <CardHeader style={{ fontWeight: "500" }}>{caption}</CardHeader>
               <ListGroup flush>
                    {rowData.map((data) => (
                         <ListGroupItem key={data.label}>
                              <div className="d-flex justify-content-between">
                                   <div className="me-3">{data.label}</div>
                                   <div>{data.value}</div>
                              </div>
                         </ListGroupItem>
                    ))}
               </ListGroup>
               <CardFooter>
                    <div className="d-flex justify-content-between align-items-center">
                         <div style={{ fontSize: "0.9rem" }}>
                              {translator.getLabel("snoozed_by")}: {snoozePayload.operator}
                         </div>
                         <div>{Footer}</div>
                    </div>
               </CardFooter>
          </Card>
     );
};

export default memo(SnoozedListItem);
